import { PropTypes } from 'prop-types';
import React from 'react';

function AbandonedCall(props) {
  const { fill } = props;
  return (
    <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#clip0_4932_1128)">
        <path
          d="M8.8418 15.1583C10.4901 16.9303 12.358 18.4846 14.4001 19.7833C15.2214 20.3074 16.1969 20.5352 17.1653 20.4291C18.1337 20.3231 19.0368 19.8894 19.7251 19.2L20.3251 18.6C20.4577 18.4676 20.5628 18.3105 20.6345 18.1374C20.7063 17.9644 20.7432 17.779 20.7432 17.5917C20.7432 17.4044 20.7063 17.2189 20.6345 17.0459C20.5628 16.8729 20.4577 16.7157 20.3251 16.5833L17.8251 14.0833C17.6928 13.9508 17.5356 13.8456 17.3626 13.7739C17.1896 13.7022 17.0041 13.6652 16.8168 13.6652C16.6295 13.6652 16.444 13.7022 16.271 13.7739C16.098 13.8456 15.9408 13.9508 15.8085 14.0833C15.539 14.347 15.1771 14.4946 14.8001 14.4946C14.4232 14.4946 14.0612 14.347 13.7918 14.0833L11.8751 12.1583"
          fill="none"
          stroke={fill}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.25"
        />
        <path
          d="M9.74151 10.025C9.60898 9.89266 9.50383 9.73548 9.43209 9.56246C9.36036 9.38944 9.32343 9.20397 9.32343 9.01667C9.32343 8.82937 9.36036 8.64391 9.43209 8.47089C9.50383 8.29787 9.60898 8.14069 9.74151 8.00834C9.87405 7.87599 9.97919 7.71881 10.0509 7.54579C10.1227 7.37277 10.1596 7.18731 10.1596 7.00001C10.1596 6.8127 10.1227 6.62724 10.0509 6.45422C9.97919 6.2812 9.87405 6.12402 9.74151 5.99167L7.24151 3.49167C7.10916 3.35914 6.95198 3.25399 6.77896 3.18226C6.60594 3.11052 6.42048 3.07359 6.23318 3.07359C6.04588 3.07359 5.86041 3.11052 5.68739 3.18226C5.51437 3.25399 5.35719 3.35914 5.22484 3.49167L4.62484 4.09167C3.93679 4.78076 3.50408 5.68373 3.39804 6.65173C3.292 7.61973 3.51896 8.59496 4.04151 9.41667C4.74384 10.5258 5.52355 11.584 6.37484 12.5833"
          fill="none"
          stroke={fill}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.25"
        />
        <path
          d="M21.375 2.625L2.625 21.375"
          fill="none"
          stroke={fill}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.25"
        />
      </g>
      <defs>
        <clipPath id="clip0_4932_1128">
          <rect fill="white" height="20" transform="translate(2 2)" width="20" />
        </clipPath>
      </defs>
    </svg>
  );
}

AbandonedCall.propTypes = {
  fill: PropTypes.string.isRequired
};

export default AbandonedCall;
